import * as React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@mui/material';
import { styled } from '@mui/system';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { BREAKPOINTS, COLORS } from '../../constants';
import { useStore } from '../../hooks';
import {
  CustomButton, DefaultVariableTableRow, CustomTextField, CustomTypography,
} from '../../components';
import { getDefaultVariableValidationSchema } from './rules';

const DEFAULT_VALUES = {
  conversation: '',
};

type FormInputsTypes = {
  conversation: string;
};

const Div = styled('div')({
  padding: '0 20rem',
  [BREAKPOINTS.BIG]: {
    padding: '0 14rem',
  },
  [BREAKPOINTS.MEDIUM]: {
    padding: '0 9rem',
  },
  [BREAKPOINTS.SMALL]: {
    padding: '0 5rem',
  },
});

export const UpdateDefaultVariablesPage: React.FC = observer(() => {
  const { handleSubmit, control } = useForm<FormInputsTypes>({
    defaultValues: DEFAULT_VALUES,
    resolver: yupResolver(getDefaultVariableValidationSchema),
  });
  const {
    defaultVariableStore: {
      defaultVariables,
      getDefaultVariables, setDefaultVariables,
    },
  } = useStore();

  const fetchDefaultVariables = async (data: FormInputsTypes): Promise<void> => {
    await getDefaultVariables(data.conversation);
  };

  useEffect(() => { setDefaultVariables([]); }, []);

  return (
    <div style={{ width: '100%' }}>
      <Div>
        <CustomTypography text="Get conversation default variables" />
        <CustomTextField name="conversation" control={control} label="Conversation" />
        <CustomButton onClick={handleSubmit(fetchDefaultVariables)} title="Get default variables" />
      </Div>

      <TableContainer component={Paper} style={{ marginTop: '2rem', width: '100%' }}>
        {defaultVariables.length ? (
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead style={{ backgroundColor: COLORS.TABLE_HEAD }}>
              <TableRow>
                <TableCell width="30%"><strong>NAME</strong></TableCell>
                <TableCell width="30%"><strong>VALUE</strong></TableCell>
                <TableCell width="10%" align="center"><strong>ACTIONS</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* eslint-disable-next-line max-len */}
              {defaultVariables.map((value) => <DefaultVariableTableRow defaultVariable={value} key={value.id} />)}
            </TableBody>
          </Table>
        ) : (
          <h4 style={{ padding: '1rem', textAlign: 'center', color: 'gray' }}>
            {/* eslint-disable-next-line max-len */}
            Enter conversation and press &apos;Get default variables&apos; button to see the variables
          </h4>
        )}
      </TableContainer>
    </div>
  );
});
